import gsap from 'gsap';
import { ease1 } from '../../easings';
import splittedText from '../../splitted-text';

const ANIMATION_SELECTORS = {
    TITLE: '.js-pc-title',
    FORM: '.js-pc-form',
};

const init = () => {
    const titleElement = document.querySelector<HTMLElement>(ANIMATION_SELECTORS.TITLE);

    const firstViewportTimeline = gsap.timeline({ defaults: { duration: 1, ease: ease1 } });

    const splittedTitleTween = titleElement ? splittedText(titleElement) : null;

    splittedTitleTween?.play();

    firstViewportTimeline.fromTo(
        ANIMATION_SELECTORS.FORM,
        {
            opacity: 0,
            y: 15,
        },
        {
            opacity: 1,
            y: 0,
            delay: 0.8,
        },
    );
};

const _module = { init };

export default _module;
